import React from "react";
import styles from "./CTASection.module.css";

export default function CTASection({ title, description, label, subLabel, href }) {
  const btn = (
    <span className={styles.iconBtn} role="button" tabIndex={0}>
      <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
        <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );

  return (
    <div className={styles.strip}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.right}>
          <div className={styles.textBlock}>
            <p className={styles.label}>{label}</p>
            <p className={styles.subLabel}>{subLabel}</p>
          </div>
          {href ? (
            <a href={href} className={styles.iconBtnLink} aria-label={`${label} ${subLabel}`}>
              {btn}
            </a>
          ) : (
            <button className={styles.iconBtn} aria-label={`${label} ${subLabel}`} type="button">
              {btn}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
